export class UploadState {
    constructor() {
        this.createFile = null;
        this.editFile = null;
        this.deleteFile = null;
    }

    clone() {
        const cloned = new UploadState();
        cloned.createFile = this.createFile;
        cloned.editFile = this.editFile;
        cloned.deleteFile = this.deleteFile;
        return cloned;
    }

    setFile(type, file) {
        switch (type) {
            case 'create':
                this.createFile = file;
                break;
            case 'edit':
                this.editFile = file;
                break;
            case 'update':
                this.updateFile = file;
                break;
            case 'replace':
                this.replaceFile = file;
                break;
            case 'delete':
                this.deleteFile = file;
                break;
        }
    }

    getFile(type) {
        switch (type) {
            case 'create':
                return this.createFile;
            case 'edit':
                return this.editFile;
            case 'update':
                return this.updateFile;
            case 'replace':
                return this.replaceFile;
            case 'delete':
                return this.deleteFile;
            default:
                return null;
        }
    }

    clearFile(type) {
        this.setFile(type, null);
    }
} 